/**
 * Convert a camelCase string to a Space Case string
 * @param {string} string 
 * @returns {string}
 */
export const toSpaceCase = (string) => {
  return string
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) { return str.toUpperCase(); })
}

/**
 * @param {string } text 
 * @returns { string }
*/
export function convertToTitleCase(text) {
  if (!text) {
    return '';
  }
  return text.trim().toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

export function convertToPascalCaseWithSpaces(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}